var map = {
	"./account.svg": "6Ytx",
	"./profile.svg": "O6ol",
	"./qrcode.svg": "1PsS"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "hPD5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icons nonrecursive \.svg$
// module id = hPD5
// module chunks = 7